export default {
  id: null,
  companyID: null,
  cityID: null,
  regionServiceID: null,
  areaID: null,
  name: null,
  cpf: null,
  email: null,
  cellPhone: null,
  budgetSystemList: null,
  regulationTypeList: null,
  schedulingTypeList: null,
  businessTypeList: null,
  insuranceList: null,
  bankID: null,
  agency: null,
  accountBank: null,
  description: null,
  status: null,
  dateUpdate: null,
  accountIDUpdate: null,
  includeKM: null,
  additionalExpenses: null,
  pix: null
}



// WEBPACK FOOTER //
// ./src/shared/models/configuration/expertmodel.js